var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseCell',[_c('InstrumentName',{attrs:{"title":_vm.title,"symbol":_vm.symbol,"name":_vm.name,"type":_vm.type,"size":"small","has-ellipsis-on-name":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }